import {
  Button,
  Icon,
  IconButton,
  SliderModal,
  TabSwitch,
  TabSwitchTypes,
  Text,
  HStack,
  VStack,
} from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { useBatchTicketCart } from '../../hooks';
import { BasketButton } from '../SectionWrapper/button';

interface BatchTicketCartProps {}

export const BatchTicketCart: React.FC<BatchTicketCartProps> = () => {
  const {
    basketSectionItemCount,
    getSliderModalWidth,
    tabs,
    handleGoBack,
    onTabPress,
    selectedTab,
    continueButtonIsDisabled,
    goToNextStep,
    handleAddItem,
    footerSectionIsVisible,
  } = useBatchTicketCart();

  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <SliderModal
      dismissWhenClickOutside
      onDismiss={handleGoBack}
      width={getSliderModalWidth(isDesktop)}>
      <VStack pt={Spacing['inline.xxs']} flex={1} space={Spacing['inline.xxxs']}>
        <HStack
          px={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxs'] }}
          borderTopRadius={{ base: BoxRadius.md, lg: 0 }}
          alignItems="center"
          justifyContent="space-between">
          <HStack
            alignItems="center"
            space={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.quarck'] }}>
            <IconButton
              testId="icon"
              icon="ArrowLeft"
              iconSize="xxs"
              p={0}
              backgroundColor="transparent"
              iconColor={Color['brand.primary.principal']}
              onPress={handleGoBack}
            />
            <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
              Resumo da cesta
            </Text>
          </HStack>
          <HStack space={Spacing['inline.xxs']} alignItems="center">
            <BasketButton count={basketSectionItemCount} />
            {!isMobile && (
              <IconButton
                testId="icon"
                icon="CloseModal"
                iconSize="xs"
                p={0}
                variant="rounded"
                borderWidth={0.05}
                backgroundColor="transparent"
                iconColor={Color['brand.primary.principal']}
                borderColor={Color['brand.primary.principal']}
                onPress={handleGoBack}
              />
            )}
          </HStack>
        </HStack>
        <Box px={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxs'] }} flex={1}>
          <TabSwitch
            testId="tab-switch"
            tabs={tabs as unknown as TabSwitchTypes.Props['tabs']}
            selectedTab={selectedTab}
            onTabPress={onTabPress as TabSwitchTypes.Props['onTabPress']}
            isMobile={isMobile}
            isLoading={false}
          />
        </Box>
      </VStack>
      {footerSectionIsVisible && (
        <HStack
          bg="neutral.white"
          alignItems="center"
          justifyContent="space-between"
          borderTopColor={'neutral.lightest'}
          p={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxs'] }}
          borderTopWidth={{ base: 0, sm: 0.5 }}>
          {!isMobile && (
            <Button
              variant="textLink"
              onPress={handleAddItem}
              rightIcon={
                <Icon name="Addition" size="xxxs" color={Color['brand.tertiary.principal']} />
              }
              _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
              ADICIONAR
            </Button>
          )}
          <Button
            w={{ base: 'full', sm: 'container' }}
            isDisabled={continueButtonIsDisabled}
            onPress={goToNextStep}
            _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
            Continuar
          </Button>
        </HStack>
      )}
    </SliderModal>
  );
};
